import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';

import { PORTAL_BASE } from '../consts';
import { GetAllServicesResponse } from '@hud/portal-dtos/webapp-service.dto';

export const ALL_SERVICES_ID = 'all-services';

export default function useAllServices() {
  const { client } = useClient('app');
  return useQuery({
    queryKey: [ALL_SERVICES_ID],
    queryFn: async () => {
      const response = await client.get(`${PORTAL_BASE}/all-services`);
      return GetAllServicesResponse.parse(response.data);
    },
  });
}
